export const validLink = (link) => {
  const pattern = /^(https?:\/\/)?(www\.)?[a-zA-Z0-9]+(\.[a-zA-Z]{2,}){1,}\/?.*$/;
  return pattern.test(link);
};
